


























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnFormContent, AcgnFormTitle } from '@/components/';
import { AcgnPopoverDetail, AcgnPopoverTask } from './components/';
import { AcgnStatisticStaffChartd } from '@/components/statistic/components';
import { namespace } from 'vuex-class';
import { Popover } from 'element-ui';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton
} from '@acgn/herm/src/ui';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Action;
import { AcgnApprovalDetail } from '@/components/';

@Component({
  components: {
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTable,
    AcgnStatisticStaffChartd,
    AcgnPopoverDetail,
    AcgnPopoverTask,
    AcgnApprovalDetail,
    [Popover.name]: Popover
  }
})

/**
 * 项目概况列表
 */
export default class AcgnTableTask extends Vue {
  private chapter: any = ''; // 章节
  @Prop() private getTableList: any;
  @Prop() private comicId: any;
  @TaskGroupAction private getTaskGroupList: any; // 获取任务组
  @TaskGroupGetter private loadings: any;

  private appro: any = false;
  private colName: any = false;
  private chapterList: any = false;
  // 列表配置
  private tableConfig: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        label: '任务名称',
        prop: 'task_name',
        render: (h: any, { row }: any) => (this as any).getTaskStadius(row)
      },
      {
        label: '审批名称',
        prop: 'dead_line'
      },
      {
        label: '审批状态',
        prop: 'id'
      },
      {
        label: '件数',
        prop: 'status',
        width: '60px'
      },
      {
        label: '完成审批时间',
        prop: 'time'
      },
      {
        label: '截止时间',
        prop: 'deline_time'
      },
      {
        label: '逾期提交',
        prop: 'is_submit',
        width: '70px'
      },
      {
        label: '逾期审批',
        prop: 'is_depart',
        width: '70px'
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              icon: `ift-fee`,
              color: '#1195e4',
              text: '查看',
              type: 'edit',
              disabled: false,
              to: {
                name: 'desk-comicAuthTask',
                params: {
                  id: this.comicId,
                  task_group_id: row.task_group_id,
                  task_id: row.task_id
                }
              },
            },
            {
              icon: `ift-fee`,
              color: '#1195e4',
              text: '审批详情',
              type: 'detail',
              disabled: false
            }
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  private searchForm: any = { // 头部筛选项
    name: '',
    username: '',
    page: 1
  };

  // 表格操作
  private onListAction(item: any) {
    const { type, row } = item;
    switch (type) {
      case 'detail':
        this.appro = true;
        return false;
    }
  }

  private getTaskList(value: any) {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    const { tableConfig, pageConfig } = this;
    const options: any = {
      page,
      size: 30
    };
    if (this.chapter) {
      options.task_group_id = this.chapter;
    }
    const { result, paging } = await this.getTableList(options);
    result.list.map((j: any) => {
      j.links.map((l: any) => {
        j[l.name] = l;
      });
    });
    this.chapterList = result.all_task_groups;
    tableConfig.data = result.list;
    pageConfig.currentPage = paging.page;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;

    const { size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  // 获取状态
  private getStadius(row: any, column: any) {
    if (row[column.label]) {
      return (
        <acgn-popover-detail row={row} column={row[column.label]}/>
      );
    } else {
      return ('');
    }
  }

  // 获取任务状态
  private getTaskStadius(row: any) {
    return (
      <acgn-popover-task row={row}/>
    );
  }
}
